import { MessageSquarePlus } from "lucide-react";
import BmcButton from "./buy-me-coffee";
import { Button } from "../ui/button";

export default function SupportSection() {
  return (
    <section id="support" className="scroll-mt-8">
      <h2 className="text-2xl font-bold tracking-tight mb-4">
        Over deze website
      </h2>
      <p className="text-muted-foreground mb-6">
        Deze website bestaat omdat ik het onhandig vond dat een simpele cijferberekeningstool ineens geld kostte.
        Dus heb ik &apos;m gebouwd voor andere docenten. Gratis. Zonder advertenties.

        Gebruik je de site regelmatig en wil je iets terugdoen, dan kan dat via de knop hieronder.
      </p>
      <div className="flex flex-wrap gap-3 items-center">
        <BmcButton />
        <Button variant="outline" asChild>
          <a
            href="https://berekencijfers.featurebase.app/"
            target="_blank"
            className="h-full"
            rel="noopener noreferrer"
          >
            <MessageSquarePlus className="mr-2 h-4 w-4" />
            Feedback of ideeën?
          </a>
        </Button>
      </div>
    </section>
  );
}
